// extracted by mini-css-extract-plugin
export default {"modal":"Kda-z","modalContent":"Lda-z","footer":"Mda-z","cancelBtn":"Nda-z","disabled":"Oda-z","formWrapper":"Pda-z","fade":"Qda-z","fade-in":"Rda-z","iframe":"Sda-z"};